import axios from 'axios';
import Cookie from 'js-cookie';
import {  toast } from 'react-toastify';
import { get, flattenDeep } from 'lodash';
import normalizer from 'json-api-normalizer';

const baseURL = process.env.REACT_APP_ENPOINT;

const api = axios.create({
  baseURL,
  timeout: 60000,
  validateStatus: () => {
    return true
  }
});

api.interceptors.request.use(
  config => {

    const { origin } = new URL(document.location.href);

    const allowedOrigins = [document.location.origin];
    const token = Cookie.get('ltfrb-site:token');
    if (allowedOrigins.includes(origin) && token) {
      config.headers.authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);


api.interceptors.response.use((response) => {
  if(response.status >= 200 && response.status < 300){
    toast.success(get(response, 'data.message'), { position: 'top-center' })
    return response.data
  }

  if(response.status >= 300 && response.status < 400){
    return response
  }

  if(response.status >= 400 && response.status < 500){

    const message422 = flattenDeep(Object.values(get(response, 'data.errors') || {}))

    const message400 = get(response, 'data.errors')

    const errorMessage = get(message400, '0.detail') || get(message422, '0') || get(response, 'data.message')

    if(response.status !== 401)
      toast.warning(errorMessage, { position: 'top-center' })

    if(response.status === 401 && ['/otp', '/sign-up'].indexOf(document.location.pathname) > -1)
      toast.warning(errorMessage, { position: 'top-center' })

    if(response.status === 401 && ['/otp', '/sign-up'].indexOf(document.location.pathname) < 0){
      Cookie.remove('ltfrb-site:token');
      window.location.href = '/';
    }

    return false
  }
},
(error) => {
   return Promise.reject(error);
})


export const normalize = (data, props) => {
  return normalizer(data, { camelizeKeys: false, ...props })
}

export default api